// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__rVqgv","resultCount":"Title_resultCount__jT8t_"};